import { render, staticRenderFns } from "./third-page.vue?vue&type=template&id=751b41ef&scoped=true&"
import script from "./third-page.vue?vue&type=script&lang=js&"
export * from "./third-page.vue?vue&type=script&lang=js&"
import style0 from "./third-page.vue?vue&type=style&index=0&id=751b41ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751b41ef",
  null
  
)

export default component.exports